import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createZitadelAuth } from '@zitadel/react';

const LoginCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const zitadel = createZitadelAuth({
      authority: process.env.REACT_APP_ZITADEL_AUTHORITY,
      client_id: process.env.REACT_APP_ZITADEL_CLIENT_ID,
      redirect_uri: window.location.origin + '/login/callback',
      response_type: 'code',
      scope: 'openid profile email',
    });

    zitadel.userManager.signinRedirectCallback()
      .then(() => {
        navigate('/');
      })
      .catch((err) => {
        console.error('Login callback error:', err);
        // Optionally, you could show an error message here
      });
  }, [navigate]);

  return <div>Processing login...</div>;
};

export default LoginCallback; 